import { render, staticRenderFns } from "./ExportAreasDialog.vue?vue&type=template&id=1219d9d6&"
import script from "./ExportAreasDialog.vue?vue&type=script&lang=ts&"
export * from "./ExportAreasDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports